import { RouteObject } from "react-router-dom";

const defaultRoutes: RouteObject[] = [
	{ path: "/", lazy: () => import("@/pages/HomePage/HomePage") },
	{
		path: "administracija",
		lazy: () => import("@/pages/Page"),
		children: [
			{ path: "korisnici", lazy: () => import("@/pages/Administration/Users/UserPage") },
			{ path: "role", lazy: () => import("@/pages/Administration/Roles/RolePage") },
			{ path: "sistematizacija", lazy: () => import("@/pages/Administration/WorkplaceSystematizations/WorkplaceSystematizations") },
			{ path: "sifrarnik", lazy: () => import("@/pages/Administration/Codebooks/Codebooks") },
			{ path: "dodatna-polja", lazy: () => import("@/pages/CustomProperties/CustomPropertiesPage") }
		]
	},
	{
		path: "poslovni-partneri",
		lazy: () => import("@/pages/Page"),
		children: [
			{ path: "pravne-osobe", lazy: () => import("@/pages/BusinessPartners/Companies/CompaniesPage") },
			{ path: "poslovnice", lazy: () => import("@/pages/BusinessPartners/PartnerBranchOffices/PartnerBranchOfficesPage") },
			{ path: "fizicke-osobe", lazy: () => import("@/pages/BusinessPartners/Persons/PersonsPage") },
			{ path: "nesvrstani-kontakti", lazy: () => import("@/pages/BusinessPartners/UnsortedContacts/UnsortedContactsPage") }
		]
	},
	{
		path: "postavke-aplikacije",
		lazy: () => import("@/pages/Page"),
		children: [
			{ path: "postanski-sanducici", lazy: () => import("@/pages/ApplicationConfig/Mailboxes/Mailbox") },
			{
				path: "konfiguracija-obavijesti/zaposlenici",
				lazy: () => import("@/pages/ApplicationConfig/NotificationsConfiguration/NotificationEmployeeConfiguration/NotificationEmployeeConfiguration")
			},
			{
				path: "konfiguracija-obavijesti/prioriteti",
				lazy: () => import("@/pages/ApplicationConfig/NotificationsConfiguration/NotificationPriorityConfiguration/NotificationPriorityConfiguration")
			},
			{
				path: "konfiguracija-obavijesti/vrste-konfiguracija",
				lazy: () => import("@/pages/ApplicationConfig/NotificationsConfiguration/NotificationTypeConfiguration/NotificationTypeConfiguration")
			}
		]
	},
	{
		path: "poruke",
		lazy: () => import("@/pages/Page"),
		children: [{ path: "mailovi", lazy: () => import("@/pages/Emails/EmailMessage/EmailMessagesPage") }]
	},
	{
		path: "bpm",
		lazy: () => import("@/pages/Page"),
		children: [
			{ index: true, lazy: () => import("@/pages/NotFoundPage") },
			{ path: "kreirani-procesi", lazy: () => import("@/pages/BusinessProcessManagement/WorkflowDefinitions/WorkflowDefinitions") },
			{ path: "pokrenuti-procesi", lazy: () => import("@/pages/BusinessProcessManagement/InitiatedWorkflows/InitiatedWorkflowsPage") }
		]
	},
	{ path: "korisnicki-profil", lazy: () => import("@/pages/UserProfiles/UserProfileDetailsPage") }
];

export default defaultRoutes;
